import { render } from "./ourTeam.vue?vue&type=template&id=27ee4b6b&ts=true"
import script from "./ourTeam.vue?vue&type=script&lang=ts"
export * from "./ourTeam.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__